import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createFocusManager from '@insight/toolkit-utils/lib/accessibility/focus/manager';

import {
  collapseAll,
  createInitiallyExpanded,
  expandAll,
  toggleExpand,
} from '../helpers';
import { AccordionProvider } from './context';

export default class Provider extends Component {
  itemIds = [];
  manager = createFocusManager({ wrap: true });
  state = {
    expanded: createInitiallyExpanded(this.props),
  };

  //listen for prop change and update expanded state when it changes
  componentDidUpdate(prevProps) {
    if (
      this.props.initiallyExpanded.toString() !==
      prevProps.initiallyExpanded.toString()
    ) {
      this.setState({ expanded: createInitiallyExpanded(this.props) });
    }
  }

  collapseAll = () => {
    this.setState({ expanded: collapseAll({ ids: this.itemIds }) });
  };

  expandAll = () => {
    this.setState({ expanded: expandAll({ ids: this.itemIds }) });
  };

  getExpanded = () => this.state.expanded;

  handleKeyDown = (e, id) => {
    this.manager.handleKeyDown(e, id, 'controls');
  };

  focusItem = (id, height) => {
    this.manager.focusItem(id, 'controls', height);
  };

  registerItem = (item) => {
    this.itemIds.push(item.id);
    this.manager.registerItem(item);
  };

  toggle = (id) => {
    const { allowMultiple, onToggle } = this.props;
    this.setState(
      ({ expanded }) => ({
        expanded: toggleExpand({
          allowMultiple,
          expanded,
          id,
          itemIds: this.itemIds,
        }),
      }),
      () => {
        onToggle && onToggle(id, this.state.expanded);
      }
    );
  };

  unregisterItem = (id) => {
    this.itemIds = this.itemIds.filter((itemId) => itemId !== id);
    this.manager.unregisterItem(id);
  };

  // Seems hacky, but this is the current recommended way to ensure minimal re-render
  // of <Provider> Components
  state = {
    ...this.state,
    collapseAll: this.collapseAll,
    expandAll: this.expandAll,
    getExpanded: this.getExpanded,
    handleKeyDown: this.handleKeyDown,
    manager: this.manager,
    registerItem: this.registerItem,
    toggle: this.toggle,
    unregisterItem: this.unregisterItem,
    focusItem: this.focusItem,
  };

  render() {
    return (
      <AccordionProvider value={this.state}>
        {this.props.children}
      </AccordionProvider>
    );
  }
}

Provider.propTypes = {
  allowMultiple: PropTypes.bool,
  children: PropTypes.node,
  onToggle: PropTypes.func,
};

Provider.defaultProps = {
  allowMultiple: false,
  children: null,
  onToggle: () => {},
};
